
import { Allotment } from 'allotment'
import { useEffect } from 'react'
import { Outlet, useLocation, useNavigation } from 'react-router-dom'

import { BackdropLoading } from '@/shared/components/BackdropLoading/BackdropLoading'
import { useAppDispatch } from '@/shared/store'
import { Divider, useTheme } from '@mui/material'

import { StyledCategoryTitle, StyledContainer, StyledHeader, StyledLeftDrawer, StyledSecondaryNavItem, StyledTitle } from './StyledAdminPage'
import { setupAdmin } from './thunks/setupAdmin'

export type AdminPageProps = {
  //
}

export const AdminPage: React.FC<AdminPageProps> = () => {
  const theme = useTheme()
  const location = useLocation()
  const locationPathName = location.pathname
  const navigation = useNavigation()
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(setupAdmin())
  }, [dispatch])

  return (
    <StyledContainer>
      <StyledHeader>
        <StyledTitle variant="h1">Admin</StyledTitle>
      </StyledHeader>
      <Allotment>
        <Allotment.Pane preferredSize={theme.layout.defaultLeftDrawerWidth} minSize={230} maxSize={320}>
          <StyledLeftDrawer>
            <StyledCategoryTitle>
              Organisation
            </StyledCategoryTitle>
            <StyledSecondaryNavItem to="/admin/groups" $active={locationPathName.includes('groups')}>
              Groups
            </StyledSecondaryNavItem>
            <StyledSecondaryNavItem to="/admin/webadmins" $active={locationPathName.includes('webadmins')}>
              Web Admins
            </StyledSecondaryNavItem>
            <StyledSecondaryNavItem to="/admin/depots" $active={locationPathName.includes('depots')}>
              Depots
            </StyledSecondaryNavItem>
            <Divider />

            <StyledCategoryTitle>
              Resources
            </StyledCategoryTitle>
            <StyledSecondaryNavItem to="/admin/runs" $active={locationPathName.includes('runs')}>
              Runs
            </StyledSecondaryNavItem>
            <StyledSecondaryNavItem to="/admin/compartments" $active={locationPathName.includes('compartments')}>
              Compartments
            </StyledSecondaryNavItem>
            <StyledSecondaryNavItem to="/admin/drivers" $active={locationPathName.includes('drivers')}>
              Drivers
            </StyledSecondaryNavItem>
            <Divider />

            <StyledCategoryTitle>
              Configurations
            </StyledCategoryTitle>
            <StyledSecondaryNavItem to="/admin/constraints" $active={locationPathName.includes('constraints')}>
              Attributes & Constraints
            </StyledSecondaryNavItem>
          </StyledLeftDrawer>
        </Allotment.Pane>
        <Allotment.Pane>
          <div style={{ width: '100%', height: '100%', backgroundColor: theme.palette.background.paper }}>
            <Outlet />
          </div>
        </Allotment.Pane>
      </Allotment>
      <BackdropLoading open={navigation.state === 'loading'} />
    </StyledContainer>
  )
}

